<template lang="pug">
  div
    .form-group
      label.control-label
        | Nova Senha
        input.form-control(type="password", v-model="newPassword")

    button.btn.btn3d.btn-sm.btn-success.confirm(@click="applyChangePassword" :disabled="!valid") Alterar senha

</template>

<script>
import Auth from '@aws-amplify/auth'

const PASSWORD_VALIDATIONS_TRANSLATE = {
  'Password does not conform to policy: Password not long enough': 'Senha muito curta',
  'Password does not conform to policy: Password must have uppercase characters': 'A senha precisa de letras em maiúsculo',
  'Password does not conform to policy: Password must have numeric characterss': 'A senha precisa ter números'
}

export default {
  props: {
    user: { type: Object, required: true }
  },
  data () {
    return {
      newPassword: ''
    }
  },
  computed: {
    valid () {
      return this.newPassword.length >= 6
    }
  },
  methods: {
    async applyChangePassword () {
      console.log('applyChangePassword', this.user)
      try {
        await Auth.completeNewPassword(
          this.user, this.newPassword, { name: this.user.challengeParam.userAttributes.email }
        )
        this.$emit('passwordChanged')
      } catch (e) {
        console.error(e)
        this.error = PASSWORD_VALIDATIONS_TRANSLATE[e.message] || 'Senha inválida'
      }
    }
  }
}
</script>
<style scoped>
.form-control {
  font-size: 18px;
  height: 50px;
}

.form-control, .control-label {
  width: 100%;
}

.confirm {
  width: 100%;
  height: 50px;
}
</style>
